import { Provider } from '@angular/core';
import {
    TRADING_QUERY_TOKEN,
    TRADING_COMMAND_TOKEN,
    TRADING_EVENTS_TOKEN,
    TradingEventsPort,
    TradingCommandPort,
    TradingQueryPort
} from '@tradgine/application-english-auction-trade';
import { TradingQueryAdapter } from './http/trading-query.adapter';
import { TradingEventsAdapter } from './web-sockets/trading-events.adapter';
import { TradingCommandAdapter } from './http/trading-command.adapter';

export function provideAuctionTrade(): Provider[] {
    return [
        {
            provide: TRADING_QUERY_TOKEN,
            useFactory: (): TradingQueryPort => new TradingQueryAdapter()
        },
        {
            provide: TRADING_COMMAND_TOKEN,
            useFactory: (): TradingCommandPort => new TradingCommandAdapter()
        },
        {
            provide: TRADING_EVENTS_TOKEN,
            useFactory: (): TradingEventsPort => new TradingEventsAdapter()
        }
    ]
}
